module.exports = __webpack_public_path__ + "img/email.12cee085.png";